import $foreign from "./foreign.cjs";
var foldl1Impl = $foreign.foldl1Impl;
var foldr1Impl = $foreign.foldr1Impl;
var traverse1Impl = $foreign.traverse1Impl;
export { foldl1Impl, foldr1Impl, traverse1Impl };
